module.exports = {
      id: "paywalliconbenefittwo-usage",
      viewBox: "0 0 34.667 27.156",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#paywalliconbenefittwo",
      toString: function () {
        return this.url;
      }
    }